import React from 'react';
import './OverviewDashboard.css'


function  OverviewDashboard () {
    
        return (
            <div>
   <div className=" dashboardWrapper">
  <div className="dashboardHeader">
    <div className="dashboardHeaderLeft">
      <h2 className="dashboardTitle">Tổng quan hệ thống</h2>
      <p className="dashboardUpdate">
        Cập nhật dữ liệu lúc: 09:30 - 23/05/2026
      </p>
    </div>

    <div className="dashboardHeaderRight">
      <button className="dashboardDateButton">
        <span className="dashboardDateIcon">📅</span>
        16/05/2026 - 23/05/2026
      </button>
    </div>
  </div>

  {/* <!-- CARD --> */}
  <div className="dashboardCardRow">
    <div className="dashboardCardItem">
      <div className="dashboardCardTop">
        <div className="dashboardCardIcon dashboardCardIconBlue">
          {/* 👥 */}
          <i className="fa-solid fa-user-group"></i>
        </div>

        <div className="dashboardCardContent">
          <p className="dashboard-card-label">Người dùng</p>
          <h3 className="dashboard-card-number">256</h3>
          <div className='increase'>
              <p className="dashboard-card-success">↑ 12 người dùng mới
            <p className='in-last-week'>so với tuần trước</p>
          </p>
          </div>
          
        </div>
      </div>
    </div>

    <div className="dashboardCardItem">
      <div className="dashboardCardTop">
        <div className="dashboardCardIcon dashboardCardIconGreen">
          🛡️
        </div>

        <div className="dashboardCardContent">
          <p className="dashboard-card-label">Vai trò</p>
          <h3 className="dashboard-card-number">18</h3>
          <p className="dashboardCardGray">Không thay đổi</p>
        </div>
      </div>
    </div>

    <div className="dashboardCardItem">
      <div className="dashboardCardTop">
        <div className="dashboardCardIcon dashboardCardIconPurple">
          {/* 💾 */}
          <i className="fa-solid fa-database"></i>
        </div>

        <div className="dashboardCardContent">
          <p className="dashboard-card-label">Dữ liệu hệ thống</p>
          <h3 className="dashboard-card-number">1.25 TB</h3>
           <div className='increase'>
              <p className="dashboard-card-success">↑ 120 GB 
            <p className='in-last-week'>so với tuần trước</p>
          </p>
          </div>
          {/* <p className="dashboard-card-success">↑ 120 GB so với tuần trước</p> */}
        </div>
      </div>
    </div>

    <div className="dashboardCardItem">
      <div className="dashboardCardTop">
        <div className="dashboardCardIcon dashboardCardIconOrange">
          📄
        </div>

        <div className="dashboardCardContent">
          <p className="dashboard-card-label">Nhật ký hệ thống</p>
          <h3 className="dashboard-card-number">12,568</h3>
           <div className='increase'>
              <p className="dashboard-card-success">↑ 8.5% 
            <p className='in-last-week'>so với tuần trước</p>
          </p>
          </div>
          {/* <p className="dashboard-card-success">↑ 8.5% so với tuần trước</p> */}
        </div>
      </div>
    </div>

    <div className="dashboardCardItem">
      <div className="dashboardCardTop">
        <div className="dashboardCardIcon dashboardCardIconRed">
          ⚠️
        </div>

        <div className="dashboardCardContent">
          <p className="dashboard-card-label">Cảnh báo</p>
          <h3 className="dashboard-card-number">5</h3>
          <p className="dashboardCardDanger">Xem chi tiết</p>
        </div>
      </div>
    </div>
  </div>

  {/* <!-- CHART --> */}
  <div className="dashboardChartRow">
    <div className="dashboardChartLeft">
      <div className="dashboardBoxHeader">
        <h3 className="dashboardBoxTitle">
          Thống kê hoạt động hệ thống
        </h3>

        <button className="dashboardFilterButton">
          7 ngày qua
        </button>
      </div>

      <div className="dashboardLegendWrapper">
        <div className="dashboardLegendItem">
          <span className="dashboardLegendBlue"></span>
          <p className="dashboardLegendText">Đăng nhập</p>
        </div>

        <div className="dashboardLegendItem">
          <span className="dashboardLegendGreen"></span>
          <p className="dashboardLegendText">Thao tác dữ liệu</p>
        </div>

        <div className="dashboardLegendItem">
          <span className="dashboardLegendRed"></span>
          <p className="dashboardLegendText">Lỗi hệ thống</p>
        </div>
      </div>

      <div className="dashboardChartContainer">
        <div className="dashboardChartYAxis">
          <span className="dashboardYAxisText">1000</span>
          <span className="dashboardYAxisText">800</span>
          <span className="dashboardYAxisText">600</span>
          <span className="dashboardYAxisText">400</span>
          <span className="dashboardYAxisText">200</span>
          <span className="dashboardYAxisText">0</span>
        </div>

        <div className="dashboardChartContent">
          <div className="dashboardChartGrid"></div>

          <svg
            className="dashboardChartSvg"
            viewBox="0 0 700 300"
            preserveAspectRatio="none"
          >
            {/* <!-- BLUE --> */}
            <polyline
              points="40,140 130,170 220,110 310,40 400,90 490,140 580,100 670,80"
              className="dashboardBlueLine"
            />

            {/* <!-- GREEN --> */}
            <polyline
              points="40,190 130,220 220,170 310,140 400,170 490,165 580,170 670,145"
              className="dashboardGreenLine"
            />

            {/* <!-- RED --> */}
            <polyline
              points="40,255 130,245 220,250 310,230 400,248 490,238 580,245 670,250"
              className="dashboardRedLine"
            />

            {/* <!-- BLUE DOT --> */}
            <circle cx="40" cy="140" r="5" className="dashboardBlueDot"></circle>
            <circle cx="130" cy="170" r="5" className="dashboardBlueDot"></circle>
            <circle cx="220" cy="110" r="5" className="dashboardBlueDot"></circle>
            <circle cx="310" cy="40" r="5" className="dashboardBlueDot"></circle>
            <circle cx="400" cy="90" r="5" className="dashboardBlueDot"></circle>
            <circle cx="490" cy="140" r="5" className="dashboardBlueDot"></circle>
            <circle cx="580" cy="100" r="5" className="dashboardBlueDot"></circle>
            <circle cx="670" cy="80" r="5" className="dashboardBlueDot"></circle>

            {/* <!-- GREEN DOT --> */}
            <circle cx="40" cy="190" r="5" className="dashboardGreenDot"></circle>
            <circle cx="130" cy="220" r="5" className="dashboardGreenDot"></circle>
            <circle cx="220" cy="170" r="5" className="dashboardGreenDot"></circle>
            <circle cx="310" cy="140" r="5" className="dashboardGreenDot"></circle>
            <circle cx="400" cy="170" r="5" className="dashboardGreenDot"></circle>
            <circle cx="490" cy="165" r="5" className="dashboardGreenDot"></circle>
            <circle cx="580" cy="170" r="5" className="dashboardGreenDot"></circle>
            <circle cx="670" cy="145" r="5" className="dashboardGreenDot"></circle>

            {/* <!-- RED DOT --> */}
            <circle cx="40" cy="255" r="5" className="dashboardRedDot"></circle>
            <circle cx="130" cy="245" r="5" className="dashboardRedDot"></circle>
            <circle cx="220" cy="250" r="5" className="dashboardRedDot"></circle>
            <circle cx="310" cy="230" r="5" className="dashboardRedDot"></circle>
            <circle cx="400" cy="248" r="5" className="dashboardRedDot"></circle>
            <circle cx="490" cy="238" r="5" className="dashboardRedDot"></circle>
            <circle cx="580" cy="245" r="5" className="dashboardRedDot"></circle>
            <circle cx="670" cy="250" r="5" className="dashboardRedDot"></circle>
          </svg>

          <div className="dashboardChartDateRow">
            <span className="dashboardDateText">16/05</span>
            <span className="dashboardDateText">17/05</span>
            <span className="dashboardDateText">18/05</span>
            <span className="dashboardDateText">19/05</span>
            <span className="dashboardDateText">20/05</span>
            <span className="dashboardDateText">21/05</span>
            <span className="dashboardDateText">22/05</span>
            <span className="dashboardDateText">23/05</span>
          </div>
        </div>
      </div>
    </div>
{/* 
    <!-- DONUT --> */}
    <div className="dashboardChartCenter">
      <div className="dashboardBoxHeader">
        <h3 className="dashboardBoxTitle">
          Phân bố người dùng theo vai trò
        </h3>
      </div>

      <div className="dashboardDonutWrapper">
        <div className="dashboardDonutChart">
          <div className="dashboardDonutCenter">
            <p className="dashboardDonutLabel">Tổng số</p>
            <h3 className="dashboardDonutNumber">256</h3>
          </div>
        </div>

        <div className="dashboardRoleList">
          <div className="dashboardRoleItem">
            <span className="dashboardRoleColor dashboardRoleColorBlue"></span>
            <p className="dashboard-role-text">
              Quản trị hệ thống <br />
              8 (3.1%)
            </p>
          </div>

          <div className="dashboardRoleItem">
            <span className="dashboardRoleColor dashboardRoleColorGreen"></span>
            <p className="dashboard-role-text">
              Lãnh đạo <br />
              12 (4.7%)
            </p>
          </div>

          <div className="dashboardRoleItem">
            <span className="dashboardRoleColor dashboardRoleColorPurple"></span>
            <p className="dashboard-role-text">
              Cán bộ nghiệp vụ <br />
              186 (72.7%)
            </p>
          </div>

          <div className="dashboardRoleItem">
            <span className="dashboardRoleColor dashboardRoleColorOrange"></span>
            <p className="dashboard-role-text">
              Doanh nghiệp <br />
              50 (19.5%)
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* <!-- QUICK --> */}
    <div className="dashboardQuickAction">
      <div className="dashboardBoxHeader">
        <h3 className="dashboardBoxTitle">Thao tác nhanh</h3>
      </div>

      <button className="dashboardQuickButton">
        👤 Thêm người dùng
      </button>

      <button className="dashboardQuickButton">
        🛡️ Thêm vai trò
      </button>

      <button className="dashboardQuickButton">
        🔑 Phân quyền
      </button>

      <button className="dashboardQuickButton">
        💾 Sao lưu dữ liệu
      </button>

      <button className="dashboardQuickButton">
        📄 Nhật ký hệ thống
      </button>

      <button className="dashboardQuickButton">
        ⚙️ Cấu hình hệ thống
      </button>
    </div>
  </div>

  {/* <!-- TABLE --> */}
  <div className="dashboardBottomRow">
    <div className="dashboardUserTable">
      <div className="dashboardBoxHeader">
        <h3 className="dashboardBoxTitle">Người dùng mới nhất</h3>

        <a href="/" className="dashboardViewAll">
          Xem tất cả
        </a>
      </div>

      <table className="dashboardTable">
        <thead className="dashboardTableHead">
          <tr className="dashboardTableHeadRow">
            <th className="dashboardTableHeadCell">STT</th>
            <th className="dashboardTableHeadCell">Họ và tên</th>
            <th className="dashboardTableHeadCell">Tên đăng nhập</th>
            <th className="dashboardTableHeadCell">Vai trò</th>
            <th className="dashboardTableHeadCell">Đơn vị</th>
            <th className="dashboardTableHeadCell">Ngày tạo</th>
            <th className="dashboardTableHeadCell">Trạng thái</th>
          </tr>
        </thead>

        <tbody className="dashboardTableBody">
          <tr className="dashboardTableBodyRow">
            <td className="dashboardTableBodyCell">1</td>
            <td className="dashboardTableBodyCell">Nguyễn Văn An</td>
            <td className="dashboardTableBodyCell">nguyenvana</td>
            <td className="dashboardTableBodyCell">Cán bộ nghiệp vụ</td>
            <td className="dashboardTableBodyCell">Phòng QLTM</td>
            <td className="dashboardTableBodyCell">23/05/2026 09:15</td>
            <td className="dashboardTableBodyCell">
              <span className="dashboardStatusActive">
                Hoạt động
              </span>
            </td>
          </tr>

          <tr className="dashboardTableBodyRow">
            <td className="dashboardTableBodyCell">2</td>
            <td className="dashboardTableBodyCell">Trần Thị Bình</td>
            <td className="dashboardTableBodyCell">tranthibinh</td>
            <td className="dashboardTableBodyCell">Doanh nghiệp</td>
            <td className="dashboardTableBodyCell">Công ty TNHH ABC</td>
            <td className="dashboardTableBodyCell">23/05/2026 08:45</td>
            <td className="dashboardTableBodyCell">
              <span className="dashboardStatusActive">
                Hoạt động
              </span>
            </td>
          </tr>

          <tr className="dashboardTableBodyRow">
            <td className="dashboardTableBodyCell">3</td>
            <td className="dashboardTableBodyCell">Lê Văn Cường</td>
            <td className="dashboardTableBodyCell">levancuong</td>
            <td className="dashboardTableBodyCell">Cán bộ nghiệp vụ</td>
            <td className="dashboardTableBodyCell">Phòng QL Năng lượng</td>
            <td className="dashboardTableBodyCell">22/05/2026 16:30</td>
            <td className="dashboardTableBodyCell">
              <span className="dashboardStatusActive">
                Hoạt động
              </span>
            </td>
          </tr>

          <tr className="dashboardTableBodyRow">
            <td className="dashboardTableBodyCell">4</td>
            <td className="dashboardTableBodyCell">Phạm Minh Đức</td>
            <td className="dashboardTableBodyCell">phamminhduc</td>
            <td className="dashboardTableBodyCell">Lãnh đạo</td>
            <td className="dashboardTableBodyCell">Ban Giám đốc</td>
            <td className="dashboardTableBodyCell">22/05/2026 14:20</td>
            <td className="dashboardTableBodyCell">
              <span className="dashboardStatusActive">
                Hoạt động
              </span>
            </td>
          </tr>

          <tr className="dashboardTableBodyRow">
            <td className="dashboardTableBodyCell">5</td>
            <td className="dashboardTableBodyCell">Hoàng Thị Mai</td>
            <td className="dashboardTableBodyCell">hoangthimai</td>
            <td className="dashboardTableBodyCell">Doanh nghiệp</td>
            <td className="dashboardTableBodyCell">Công ty CP XYZ</td>
            <td className="dashboardTableBodyCell">22/05/2026 10:05</td>
            <td className="dashboardTableBodyCell">
              <span className="dashboardStatusActive">
                Hoạt động
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    {/* <!-- ALERT --> */}
    <div className="dashboardAlertBox">
      <div className="dashboardBoxHeader">
        <h3 className="dashboardBoxTitle">Cảnh báo hệ thống</h3>

        <a href="/" className="dashboardViewAll">
          Xem tất cả
        </a>
      </div>

      <div className="dashboardAlertItem">
        <div className="dashboardAlertLeft">
          <span className="dashboardAlertRed">
            {/* ⚠️ */}
            <i className="fa-solid fa-triangle-exclamation icon-triangle-exclamation"></i>
            </span>

          <div className="dashboardAlertContent">
            <p className="dashboard-alert-title">
              Dịch vụ kết nối LGSP không phản hồi
            </p>

            <span className="dashboardAlertSub">
              lgsp-connector
            </span>
          </div>
        </div>

        <div className="dashboardAlertRight">
          <p className="dashboardAlertTime">09:25</p>
          <span className="dashboardAlertDate">23/05/2026</span>
        </div>
      </div>

      <div className="dashboardAlertItem">
        <div className="dashboardAlertLeft">
          <span className="dashboardAlertYellow">⚠️</span>

          <div className="dashboardAlertContent">
            <p className="dashboard-alert-title">
              Dung lượng lưu trữ đạt 85%
            </p>

            <span className="dashboardAlertSub">
              storage-server-01
            </span>
          </div>
        </div>

        <div className="dashboardAlertRight">
          <p className="dashboardAlertTime">08:40</p>
          <span className="dashboardAlertDate">23/05/2026</span>
        </div>
      </div>
      {/* dòng 3 */}
       <div className="dashboardAlertItem">
        <div className="dashboardAlertLeft">
          <span className="dashboardAlertYellow">⚠️</span>

          <div className="dashboardAlertContent">
            <p className="dashboard-alert-title">
              Có 3 người đăng nhập sai mật khẩu liện tiếp
            </p>

            <span className="dashboardAlertSub">
              security-service
            </span>
          </div>
        </div>

        <div className="dashboardAlertRight">
          <p className="dashboardAlertTime">07:15</p>
          <span className="dashboardAlertDate">23/05/2026</span>
        </div>
      </div>
      {/* dòng 4 */}
       <div className="dashboardAlertItem">
        <div className="dashboardAlertLeft">
          <span className="dashboardAlertBlue">
            <i className="fa-solid fa-circle-exclamation"></i>
            {/* ⚠️ */}
            </span>

          <div className="dashboardAlertContent">
            <p className="dashboard-alert-title">
             Hoàn tất sao lưu hệ thống
            </p>

            <span className="dashboardAlertSub">
              backup-service
            </span>
          </div>
        </div>

        <div className="dashboardAlertRight">
          <p className="dashboardAlertTime">02:30</p>
          <span className="dashboardAlertDate">23/05/2026</span>
        </div>
      </div>
    </div>

    {/* <!-- INFO --> */}
    <div className="dashboardInfoBox">
      <div className="dashboardBoxHeader">
        <h3 className="dashboardBoxTitle">Thông tin hệ thống</h3>
      </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Phiên bản hệ thống</span>
        <span className="dashboardInfoValue">v2.1.0</span>
      </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Môi trường</span>
        <span className="dashboardInfoValue">Production</span>
      </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Máy chủ</span>
        <span className="dashboardInfoValue">SV-CTAG-01</span>
      </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Hệ điều hành</span>
        <span className="dashboardInfoValue">Ubuntu 22.04 LTS</span>
      </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Cơ sở dữ liệu</span>
        <span className="dashboardInfoValue">PostgreSQL 15</span>
      </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Dung lượng lưu trữ</span>
        <span className="dashboardInfoValue">
          1.25 TB / 2 TB (62%)
        </span>
      </div>
      {/* thanh bên dưới */}
       <div className="storageProgressBar">
      <div className="storageProgressFill"></div>
    </div>

      <div className="dashboardInfoItem">
        <span className="dashboardInfoLabel">Thời gian hoạt động</span>
        <span className="dashboardInfoValue">
          15 ngày 07:45:12
        </span>
      </div>
    </div>
  </div>
</div>

            </div>
        );
    
}



export default OverviewDashboard;